import * as React from "react";
import { memo } from "react";

const SvgHeightChair = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 11 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.674 11.236a2.998 2.998 0 0 0 1-2.241v-1a1.333 1.333 0 0 0 0-2.665V2.44A2.442 2.442 0 0 0 6.235 0H3.784a2.442 2.442 0 0 0-2.439 2.439V5.33a1.333 1.333 0 0 0 0 2.665v1a2.998 2.998 0 0 0 1 2.242L.011 19.564a.334.334 0 0 0 .643.18l1.156-4.088h6.396l1.133 4.088a.345.345 0 1 0 .666-.18l-2.332-8.329Zm-1.998.09h-.314a2.665 2.665 0 0 1 2.646-2.331 2.332 2.332 0 0 1-2.332 2.332ZM2.01 2.44A1.775 1.775 0 0 1 3.784.666h2.448A1.776 1.776 0 0 1 8.008 2.44V5.33H2.01V2.44ZM.68 6.663a.666.666 0 0 1 .666-.667h7.329a.666.666 0 1 1 0 1.333H1.345a.666.666 0 0 1-.666-.666Zm7.329 1.332v.333a3.331 3.331 0 0 0-2.999 1.89 3.331 3.331 0 0 0-2.998-1.89v-.333h5.997Zm-5.997 1a2.666 2.666 0 0 1 2.645 2.332h-.313a2.332 2.332 0 0 1-2.332-2.332Zm0 5.996.94-3.351c.428.23.906.35 1.392.353h1.333c.491 0 .975-.121 1.409-.353l.923 3.351H2.01Z"
      fill="#000"
    />
  </svg>
);

const Memo = memo(SvgHeightChair);
export default Memo;
